export default "__VITE_ASSET__DIzGkwof__"